module.exports = __webpack_public_path__ + "static/media/alessandrobruno.1e0df3fb.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/alessandrobruno.webp
// module id = 879
// module chunks = 0